import { render } from "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=template&id=1abca3bc&scoped=true"
import script from "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=style&index=0&id=1abca3bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abca3bc"]])

export default __exports__